import { useEffect } from 'react'

function useEventHandler(event, cb, target, options) {
  if (!target && typeof window !== 'undefined') {
    target = window
  }

  useEffect(() => {
    if (options && options.disabled) {
      return
    }

    if (target) target.addEventListener(event, cb, options)
    return () => {
      if (target) target.removeEventListener(event, cb)
    }
  }, [event, cb, target, options])
}

export default useEventHandler
